class EfdFilter {
  static get $inject() {
    return ['gql', '$filter', '$scope']
  }

  constructor(gql, $filter, $scope) {
    this.gql = gql
    this.$filter = $filter
    this.filter = { tipo: "ICMS" }
    this.mesesReferencia = this.buildMeses()

    this.apply = (fun) => $scope.$apply(fun)

    $scope.$watch(() => this.filter, () => {
      setTimeout(() => this.apply(() => this.submit()), 0)
    }, true)
  }

  buildMeses() {
    const today = new Date()

    let month = today.getMonth()
    const dates = []

    for (let i = 1; i < 24; i++) {
      dates.push(new Date(today.getFullYear(), month, 1))
      month -= 1
    }

    return dates
  }

  submit() {
    if (this.form && this.form.$valid) {
      this.updateFilter()
    } else {
      this.onChange({ $newFilter: null })
    }
  }

  updateFilter() {
    let filter = angular.copy(this.filter)

    if (filter.dataReferencia)
      filter.dataReferencia = this.$filter('date')(filter.dataReferencia, 'yyyy-MM-dd')

    this.onChange({ $newFilter: filter })
  }
}

angular.module('eficienciaFiscalModule').component('efdFilter', {
  controller: EfdFilter,
  bindings: {
    onChange: '&',
    contratoId: '<'
  },
  template: `
    <form class="fade-animation" name="$ctrl.form" ng-submit="$ctrl.submit()">
      <div class="row">
        <ef-filiais-selector class="form-group col-sm-12" name="filiaisIds" ng-model="$ctrl.filter.filiaisIds"
          contrato-id="$ctrl.contratoId" ferramenta="arquivos-digitais" cache-as="efd-list" required>
        </ef-filiais-selector>
        <div class="form-group col-sm-5">
          <label>Tipo do arquivo</label>
          <div class="smart-form">
            <div class="inline-group" style="display: flex; justify-content: space-between;">
              <label class="radio no-break">
                <input type="radio" ng-model="$ctrl.filter.tipo" value="ICMS" ng-checked="true">
                <i></i> EFD ICMS-IPI
              </label>
              <label class="radio no-break">
                <input type="radio" ng-model="$ctrl.filter.tipo" value="PIS_COFINS">
                <i></i> EFD Contribuições
              </label>
            </div>
          </div>
        </div>
        <div class="form-group col-sm-4">
          <label>
            Mês de referência
            <i class="fa fa-trash-o text-danger cursor-pointer" ng-click="$ctrl.filter.dataReferencia = undefined"
              ng-if="$ctrl.filter.dataReferencia"></i>
          </label>
          <select class="form-control" ng-model="$ctrl.filter.dataReferencia"
            ng-options="mes as (mes | date:'MMMM/yyyy') for mes in $ctrl.mesesReferencia">
            <option value="null">...</option>
          </select>
        </div>
        <div class="form-group col-sm-3">
          <label for="" class="hidden-xs">&nbsp;</label>
          <button type="submit" class="btn btn-primary btn-block"><i class="fa fa-refresh"></i> Atualizar</button>
        </div>
      </div>
    </form>
  `
})
